/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tough_Royal_Donkey_AspireInputs */

const fr_tough_royal_donkey_aspire = /** @type {(inputs: Tough_Royal_Donkey_AspireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le paiement a été annulé`)
};

/**

* @param {Tough_Royal_Donkey_AspireInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tough_royal_donkey_aspire = /** @type {((inputs?: Tough_Royal_Donkey_AspireInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tough_Royal_Donkey_AspireInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tough_royal_donkey_aspire(inputs)
});